/// <reference path="../../auth_form_default/js/gmr.d.ts" />
/// <reference path="../../auth_form_default/js/IFormState.d.ts" />
/// <reference path="IFormOptions.d.ts" />
import DefaultForm from '../../auth_form_default/js/DefaultForm';
import sendGtmEvent from "../../helpers/sendGtmEvent";

export default class DownloadForm extends DefaultForm {
    $form: JQuery;
    $download_button: JQuery;
    form_id = 'downloadForm';
    gmr: GMR;
    options: IFormOptions;

    constructor() {
        super();
        this.options = {};
        this.state = {
            rendered: false,
            visible: false
        };
    }


    public init(options: IFormOptions) {
        this.parseOptions(options);
        this.renderForm();
    }

    public initGameCenterConnect() {
        return this.gmr.detectGameCenter();
    }

    private parseOptions(options: IFormOptions) {
        if (!options.gmr) {
            throw new Error('GMR is not defined');
        }
        this.gmr = options.gmr;
        this.options = options;
    }


    private renderForm() {
        var html = this.getHtmlTemplate();
        $('body').append(html);
        this.$form = $('#' + this.form_id);
        this.$download_button = $('.download-form__button-download', this.$form);
        this.$download_button.attr('href', this.gmr.settings.download_url);
        this.state.rendered = true;
        this.initEvents();
        if (this.options.visible) {
            this.showForm();
        } else {
            this.hideForm();
        }
    }

    private initEvents() {
        var that = this;
        this.initGameCenterConnect().done(this.buttonEventGC.bind(this)).fail(this.buttonEvent.bind(this));

        $('.js-button--close', this.$form).on('click', function () {
            that.hideForm();
            return false;
        });
    }

    private buttonEvent() {
        var that = this;
        if (!this.$form) {
            throw new Error('Form is not rendered');
        }
        this.$download_button.on('click', function (e) {

            this.gmr.showDownloadHint();
            that.hideForm();
            return true;
        });
    }

    private buttonEventGC() {
        var that = this;
        this.$download_button.on('click', function (e) {
            sendGtmEvent("ch.click.download");
            e.preventDefault();
            that.gmr.detectAndDownload();
            return false;
        });
    }

    private getHtmlTemplate() {
        var id = this.form_id;
        var html = `
        <div class="popup-wrapper" id="${id}">
            <div class="download-form">
                <div class="download-form__logo"></div>
                <h3 class="download-form__header">Вы успешно<br/>зарегистрированы в игре</h3>
                <div class="download-form__close-button js-button--close"></div>
                <a class="download-form__button-download news_custom_link js-button--confirm-reg"
                href="https://static.dl.mail.ru/SkyforgeLoader.exe" >Скачать игру</a>
                <p class="download-form__rules-text">Посетить
                    <a href="https://sf.mail.ru">сайт игры</a>
                </p>
            </div>
        </div>`;
        return html.replace(/\s\s*$/gm, "");
    }
}
